import { render, staticRenderFns } from "./ManageAssignmentModal.vue?vue&type=template&id=795e21c9&scoped=true&"
import script from "./ManageAssignmentModal.vue?vue&type=script&lang=js&"
export * from "./ManageAssignmentModal.vue?vue&type=script&lang=js&"
import style0 from "./ManageAssignmentModal.vue?vue&type=style&index=0&id=795e21c9&prod&scoped=true&lang=css&"
import style1 from "./ManageAssignmentModal.vue?vue&type=style&index=1&id=795e21c9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795e21c9",
  null
  
)

export default component.exports